import { getSalonAdminApiBaseUrl } from "./apiConfig";

const rawApiBase = getSalonAdminApiBaseUrl();

export const API_BASE = rawApiBase.replace(/\/+$/, "");

// Auth via HttpOnly cookie (credentials: 'include'). Do not attach JWT from localStorage.
export const api = (endpoint, options = {}) => {
  const normalizedEndpoint = endpoint?.startsWith("/") ? endpoint : `/${endpoint || ""}`;
  const { headers: optionHeaders, ...restOptions } = options;

  return fetch(`${API_BASE}${normalizedEndpoint}`, {
    method: options.method || "GET",
    credentials: "include",
    ...restOptions,
    headers: {
      "Content-Type": "application/json",
      ...(optionHeaders || {}),
    },
  });
};
